import { MANUAL_LINKS, type ManualLinkKey } from './manualLinks';

/**
 * 막힌 자리에서 바로 매뉴얼로 가는 작은 `?` 링크.
 *
 * - **반드시 새 탭**: 에디터는 저장되지 않은 편집 상태를 들고 있어 같은 탭 이동은 작업 유실이다.
 * - **레이아웃 중립**: 아이콘 자체는 16px 정사각(주변 행 높이 = text-[11px] 줄 높이)이고, 클릭
 *   히트 영역만 `before:` 절대배치 오버레이로 넓힌다(흐름에 영향 없음).
 * - `<summary>`/행 클릭 핸들러 안에 얹히는 자리가 있어 클릭은 여기서 멈춘다(details 토글·행 선택
 *   같은 부작용 방지).
 */
export function HelpLink({ topic, className }: { topic: ManualLinkKey; className?: string }) {
  const { href, label } = MANUAL_LINKS[topic];
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      title={`${label} (매뉴얼 · 새 탭)`}
      aria-label={`${label} — 매뉴얼을 새 탭에서 엽니다`}
      onClick={(e) => e.stopPropagation()}
      className={`relative inline-flex h-4 w-4 shrink-0 select-none items-center justify-center rounded-full border border-gray-300 bg-white align-middle text-[10px] font-medium leading-none text-gray-500 no-underline before:absolute before:-inset-1.5 before:content-[''] hover:border-brand-400 hover:bg-brand-50 hover:text-brand-600${
        className ? ` ${className}` : ''
      }`}
    >
      <span aria-hidden>?</span>
    </a>
  );
}
